//
//  useGhaCsvExport.ts
//
//  isana.net,inc. Proprietary and Confidential
//

import { useState } from "react";
import {
  getGhaExportedDailyCsv,
  getGhaExportedIntradayCsv,
} from "../network/ghaCsv/api";

const SUCCESS_MESSAGE =
  "CSV作成のリクエストを受け付けました。完了次第、作成済みCSV一覧に追加されます。";
const FAILURE_MESSAGE = "CSV作成の受け付けに失敗しました。";

const useGhaCsvExport = (
  showMessage: (msg: string, type: "success" | "error") => void
) => {
  // リクエスト中はtrue。ボタンを無効化して連打による重複リクエストを防ぐ
  const [isExporting, setIsExporting] = useState(false);

  const requestGhaCsvExport = async (
    apiCall: () => Promise<{ status: number; data?: { message?: string } }>,
    errorLogPrefix: string
  ): Promise<void> => {
    setIsExporting(true);
    try {
      const response = await apiCall();
      if (response.status >= 200 && response.status < 300) {
        showMessage(SUCCESS_MESSAGE, "success");
      } else if (response.status === 404) {
        showMessage(response.data?.message ?? FAILURE_MESSAGE, "error");
      } else {
        showMessage(FAILURE_MESSAGE, "error");
      }
    } catch (error: any) {
      console.error(errorLogPrefix, error);
      showMessage(error.response?.data?.message ?? FAILURE_MESSAGE, "error");
    } finally {
      setIsExporting(false);
    }
  };

  const handleGhaDailyCsvExport = (
    startDate: string,
    endDate: string,
    summaryItemIds: string
  ): Promise<void> =>
    requestGhaCsvExport(
      () => getGhaExportedDailyCsv(startDate, endDate, summaryItemIds),
      "GHA 日次 CSV エクスポート中にエラーが発生しました:"
    );

  const handleGhaIntradayCsvExport = (
    startDate: string,
    endDate: string,
    intradayItemId: string
  ): Promise<void> =>
    requestGhaCsvExport(
      () => getGhaExportedIntradayCsv(startDate, endDate, intradayItemId),
      "GHA 時系列 CSV エクスポート中にエラーが発生しました:"
    );

  return { handleGhaDailyCsvExport, handleGhaIntradayCsvExport, isExporting };
};

export default useGhaCsvExport;
